<template>
  <div class="container-fluid">
    <div class="row d-flex justify-content-center">
      <div class="col-lg-10">
        <h1 class="heading-color text-center p-5">{{photoName}} Photo Categories</h1>
      </div>
    </div>
    <div class="row d-flex justify-content-center" v-if="this.$store.getters.apiStatus !== 'loading'">
      <div class="col-lg-10">
        <div class="overlay">
          <div class="main-loader">
            <MainLoader></MainLoader>
          </div>
        </div>
        <div class="row" v-if="categories.length">
          <ItemCard v-for="category in categories" :key="category.id" :item="category" :nextLink="'/photo/' + photoId + '/categories/' + category.name + '/photo-images'"></ItemCard>
        </div>
        <div class="not-found-div" v-else>
          <div class="row">
            <div class="col-md-12">
              <p class="text-center">No categories found in {{photoName}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-loader" v-else>
      <MainLoader></MainLoader>
    </div>
  </div>
</template>

<script>
import ItemCard from '@/components/ItemCard'
export default {
  name: 'PhotoImageCategories',
  components: {
    ItemCard
  },
  data () {
    return {
      categories: [],
      photoName: '',
      photoId: ''
    }
  },
  mounted () {
    this.fetchPhotoImages()
  },
  methods: {
    fetchPhotoImages () {
      this.categories = []
      $('.overlay').removeClass('d-none')
      this.$store.dispatch('fetchPhotoImages', { photoID: this.$route.params.photo_id })
        .then((result) => {
          this.categories = result.data.photo_image_categories
          $('.overlay').addClass('d-none')
          this.photoName = result.data.photo_name
          this.photoId = result.data.photo_id
          document.title = 'Img-Lib - ' + this.photoName + ' photo images'
        })
        .catch((err) => this.$helper.catchHandler(err))
    }
  }
}

</script>

<style scoped>
.not-found-div {
  height: calc(70vh - 190px);
}
@media screen and (max-width: 500px){
  .not-found-div {
    height: calc(70vh - 100px);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PhotoImageCategories.vue